<div class="vas-information">
  <app-ice-pill class="vas-offering-information" type="neutral" [isInteractive]="false">
    {{ vasProduct?.productName }}
    <span>
      @if (vasProduct?.monthlyPrice?.price?.includingVAT > 0) {
        <span>&ensp;+</span>
      }
      <span>
        {{ vasProduct?.monthlyPrice?.price | priceFormat: PriceType.Monthly : 'Inkludert' }}
      </span>
    </span>
  </app-ice-pill>
  <app-unique-selling-points [VASProductName]="vasProduct?.productName" />
</div>
